<template>
  <div id="page-layout-container">
    <router-view v-slot="{ Component }">
      <transition name="slide-fade">
        <component :is="Component" />
      </transition>
    </router-view>

  </div>

</template>
<script lang="ts" setup>
</script>

<style lang="scss">
#page-layout-container {
  opacity: 1;
  background: #F4F5F7;
  position: relative;
  overflow: hidden;
  height: 100vh;
}
</style>
